import {ConfigurationSmartLinkResponse, CreditDetailsResponse, SmartLinkResponse} from "@/types/service-response";

export default class SmartLink {
  private constructor (
    readonly actionKind: any,
    readonly activeFrom: string,
    readonly activeUntil: string,
    readonly createdAt: string,
    readonly id: string,
    readonly requestKinds: any[],
    readonly slug: string,
    readonly tenant: string,
    readonly configuration: ConfigurationSmartLinkResponse[]
  ) {}


  static createFromResponse (responseData: SmartLinkResponse): SmartLink {
    return new SmartLink(
        responseData.actionKind,
        responseData.activeFrom,
        responseData.activeUntil,
        responseData.createdAt,
        responseData.id,
        responseData.requestKinds,
        responseData.slug,
        responseData.tenant,
        responseData.configuration
    )
  }

  static createFromResponseList (responseData: SmartLinkResponse[]): SmartLink[]{
    return  responseData.map((item: SmartLinkResponse)=>{
      return new SmartLink(
          item.actionKind,
          item.activeFrom,
          item.activeUntil,
          item.createdAt,
          item.id,
          item.requestKinds,
          item.slug,
          item.tenant,
          item.configuration
      )
        }
    )
  }


}